<template>
    <div class="task-detail-container">
        <div class="card-box task-info-box">
            <div class="task-info-brand">
                <img
                    v-if="detailData.platform.value === 10"
                    class="brand-logo"
                    src="../../assets/taskDetail/xiaohongshu.png"
                />
                <img
                    v-if="detailData.platform.value === 20"
                    class="brand-logo"
                    src="../../assets/taskDetail/douyin.png"
                />
                <img
                    v-if="detailData.platform.value === 30"
                    class="brand-logo"
                    src="../../assets/taskDetail/kuaishou.png"
                />
                <img
                    v-if="detailData.platform.value === 40"
                    class="brand-logo"
                    src="../../assets/taskDetail/weibo.jpeg"
                />
                <img
                    v-if="detailData.platform.value === 50"
                    class="brand-logo"
                    src="../../assets/taskDetail/dazhong.png"
                />
                <img
                    v-if="detailData.platform.value === 60"
                    style="color: #47c920"
                    class="brand-logo"
                    src="../../assets/taskDetail/weixin.png"
                />
                <div
                    v-if="
                        detailData.exemptEmployFlag === 1 ||
                        detailData.exemptManuscriptFlag === 1
                    "
                    class="brand-right"
                >
                    <span class="task-name">{{ detailData.name }}</span>
                </div>
                <div v-else class="brand-rightTwo">
                    <span class="task-name">{{ detailData.name }}</span>
                </div>
            </div>
            <div class="sign-total">
                <div
                    v-if="detailData.exemptEmployFlag === 1"
                    class="label-sign"
                >
                    100%录用
                </div>
                <div
                    v-if="detailData.exemptManuscriptFlag === 1"
                    class="label-sign"
                >
                    免审稿
                </div>
            </div>
            <div class="task-type-icon">
                <div
                    class="typeLogo"
                    v-if="detailData.type && detailData.type.value === 10"
                >
                <!-- detailData.amount > 0 && -->
                    <div class="center-text" v-if="detailData.amount > 0 && detailData.rewardType !== 1">现金</div>
                    <div style="margin-top: -10px; margin-bottom: -5px"
                        v-if="detailData.amount > 0 && detailData.rewardType !== 1&&detailData.rewardType !== 2">
                        +
                    </div>
                    <!-- v-if="detailData.marketHandleType.value === 10" -->
                    <div class="center-text" v-if="detailData.rewardType !== 2">
                        赠送
                    </div>
                </div>
                <div class="typeLogo" v-else-if="detailData.type && detailData.type.value === 20">
                    <span class="center-text" v-if="detailData.amount > 0 && detailData.rewardType !== 1">现金</span>
                    <span
                        v-if="detailData.amount > 0 && detailData.rewardType !== 1&&detailData.rewardType !== 2">
                        +
                    </span>
                    <span class="center-text"  v-if="detailData.rewardType !== 2">赠送</span>
                </div>
                <div class="sanjiaoxing"></div>
            </div>
            <!--            <img v-if="detailData.type && detailData.type.value===10" class="task-type-icon" src="../../assets/home/type_10.png" />-->
            <!--            <img v-else-if="detailData.type && detailData.type.value===20" class="task-type-icon" src="../../assets/home/type_20.png" />-->
            <!--            <img v-else-if="detailData.type && detailData.type.value===30" class="task-type-icon" src="../../assets/home/type_30.png" />-->

            <div class="task-data-box">
                <img
                    class="left-logo"
                    @click="previewImage(detailData.products[0].imageUrl)"
                    :src="detailData.products[0].imageUrl"
                />
                <div class="right-data">
                    <div class="cell">
                        <span class="label">已录用:</span>
                        <span class="value">{{ detailData.applyTotal }}人</span>
                        <!-- needPeople applyPeopleMax -->
                        <span class="label" style="margin-left: 10px"
                            >已招募:
                            <span class="value">{{ detailData.applySuccessTotal }}人</span>
                            </span
                        >
                    </div>
                    <div class="cell">
                        <span class="label">商品名称:</span>
                        <span class="value">{{
                            detailData.products[0].name
                        }}</span>
                        <!--                        <span class="task-platform"-->
                        <!--                              :style="{background: detailData.platformColor}">{{detailData.platform && detailData.platform.desc}}</span>-->
                    </div>
                    <div class="cell">
                        <span class="label">粉丝要求:</span>
                        <span class="value" v-if="detailData.fansMin>0">{{ detailData.fansMin }}+</span>
                        <span class="value" v-else>无限制</span>
                    </div>
                    <div class="cell">
                        <span class="label">稿  费:</span>
                        <span class="value">¥{{ detailData.amount }}</span>
                    </div>
                    <div
                        class="cell"
                        v-if="
                            detailData.type.value === 10 &&
                            detailData.marketType.value === 20 &&
                            detailData.marketHandleType.value === 10
                        "
                    >
                        <span class="label">赠品:</span>
                        <span class="value">{{
                            detailData.products[0].name
                        }}</span>
                        <span class="label" style="margin-left: 10px"
                            >价值{{ detailData.products[0].price }}元</span
                        >
                    </div>
                    <div class="cell" v-if="detailData.type.value === 20">
                        <span class="label">赠品:</span>
                        <span class="value">{{
                            detailData.products[0].name
                        }}</span>
                        <span class="label" style="margin-left: 10px"
                            >价值{{ detailData.products[0].price }}元</span
                        >
                    </div>
                </div>
            </div>
            <div class="info-font">
                <span v-if="detailData.type && detailData.type.value === 10">
                    <span v-if="detailData.marketType.value === 10">
                        录用后，需按照商家要求撰写感受发布在{{
                            detailData.platform.desc
                        }}平台
                    </span>
                    <span v-if="detailData.marketType.value === 20">
                        试用后，需按照商家的要求撰写感受发布在{{
                            detailData.platform.desc
                        }}平台
                    </span>
                </span>
                <span v-if="detailData.type && detailData.type.value === 20">
                    需按时到线下店试用，并按要求撰写感受发布在{{
                        detailData.platform.desc
                    }}平台
                </span>
            </div>
            <!--            <div class="task-data-box">-->
            <!--                <div class="row">-->
            <!--                    <div class="cell">-->
            <!--                        <span class="label">任务酬劳：</span>-->
            <!--                        <template v-if="detailData.amount > 0">-->
            <!--                            <span class="money">{{detailData.amount}}</span>-->
            <!--                        </template>-->
            <!--                        <template v-else>-->
            <!--                            <span class="money">置换</span>-->
            <!--                        </template>-->
            <!--                    </div>-->
            <!--                    <div class="cell">-->
            <!--                        <span class="label">粉丝要求：</span>-->
            <!--                        <span class="value">{{detailData.fansMin}}</span>-->
            <!--                    </div>-->
            <!--                </div>-->
            <!--                <div class="row">-->
            <!--                    <div class="cell">-->
            <!--                        <span class="label">招募人数：</span>-->
            <!--                        <span class="value">{{detailData.needPeople}}</span>-->
            <!--                    </div>-->
            <!--                    <div class="cell">-->
            <!--                        <span class="label">报名人数：</span>-->
            <!--                        <span class="value">{{detailData.applyTotal}}</span>-->
            <!--                    </div>-->
            <!--                </div>-->
            <!--                <div class="row">-->
            <!--                    <template v-if="detailData.type && detailData.type.value !== 30 && !detailData.exemptManuscriptFlag">-->
            <!--                        <div class="cell">-->
            <!--                            <span class="label">交稿时间：</span>-->
            <!--                            <span class="value">{{detailData.handoverEndTime}}</span>-->
            <!--                        </div>-->
            <!--                    </template>-->
            <!--                    <div class="cell">-->
            <!--                        <span class="label">结算时间：</span>-->
            <!--                        <span class="value">{{detailData.settleEndTime}}</span>-->
            <!--                    </div>-->
            <!--                </div>-->
            <!--                <div class="row">-->
            <!--                    <div class="cell">-->
            <!--                        <span class="label">剩余报名时间：</span>-->
            <!--                        <span class="value" style="color: #E02020;">{{detailData.timeFromNow}}</span>-->
            <!--                    </div>-->
            <!--                </div>-->
            <!--            </div>-->
        </div>
        <!--        品牌logo+品牌名称+品牌关注人数-->
        <div class="card-box" @click="goToBrand">
            <div style="display: flex;justify-content: space-between;align-items: center;">
                <img class="brandLogoUrl" :src="detailData.brandLogoUrl" />
                <span class="brand-name">{{ detailData.brandName }}</span>
                <span class="brand-attention"
                    ><img
                        class="heart"
                        src="../../assets/taskDetail/collectHeart.png"
                    />{{ attentionCount }}人关注<span style="font-size: 20px">
                        >
                    </span></span
                >
            </div>
        </div>
        <!--探店地址-->
        <div
            class="card-box"
            v-if="detailData.type && detailData.type.value === 20"
        >
            <div style="padding-bottom: 20px;display: flex;align-items: center;">
                <img
                    class="shop-icon"
                    src="../../assets/taskDetail/address.png"
                />
                <span class="brand-name">{{
                    detailData.merchantAddressRealName
                }}</span>
                <span
                    style="font-size: 12px; color: #999999; margin-left: 5px"
                    v-if="detailData.distance === ''"
                    >未知</span
                >
                <span
                    v-else
                    style="font-size: 12px; color: #999999; margin-left: 5px"
                    >(距您<span>{{ detailData.distance }}</span
                    >米）</span
                >
            </div>
            <div style="display: flex; align-items: center;">
                <img
                    class="shop-icon"
                    src="../../assets/taskDetail/location.jpeg"
                />
                <span
                    class="shop-font"
                    style="
                        margin-left: 10px;
                        width: 200px;
                        white-space: normal;
                        word-break: break-all;
                        word-wrap: break-word;
                    "
                    >{{ detailData.merchantAddress }}</span
                >
                <div class="navigation" @click="goToAddress(detailData)">
                    <img
                        class="shop-icon"
                        style="margin-bottom: 5px"
                        src="../../assets/taskDetail/daohang.png"
                    />
                    <span class="shop-font">导航</span>
                </div>
                <div class="shop-font line">|</div>
                <div
                    class="phone"
                    @click="callPhone(detailData.merchantAddressPhone)"
                >
                    <img
                        class="shop-icon"
                        style="margin-bottom: 5px"
                        src="../../assets/taskDetail/phone.png"
                    />
                    <span class="shop-font">电话</span>
                </div>
            </div>
            <div class="time-period">
                您需要在
                {{
                    detailData.taskApplyRules[0].applyStartTime.substring(0, 10)
                }}
                至
                {{ detailData.taskApplyRules[0].applyEndTime.substring(0, 10) }}
                前完成到店
            </div>
        </div>

        <div class="card-box task-require-class">
            <div class="title-class">
                <div class="brand-detail-title">发布要求</div>
                <div class="count-down">
                    剩余报名时间：<span v-if="remainingTime === ''"
                        >报名已结束</span
                    ><van-count-down
                        v-else
                        style="
                            font-size: 12px;
                            color: #ff7e20;
                            display: inline-block;
                        "
                        :time="remainingTime"
                        format="DD 天 HH:mm:ss"
                    />
                </div>
            </div>
            <div class="need-class">
                <div style="width: 35%">
                    曝光：{{ detailData.exposureQuantity === 0?'-':detailData.exposureQuantity }}
                </div>
                <div style="width: 35%">
                    评论：{{ detailData.commentQuantity === 0?'-':detailData.commentQuantity }}
                </div>
                <div style="width: 35%">
                    点赞：{{ detailData.likeQuantity === 0?'-':detailData.likeQuantity }}
                </div>
            </div>
            <!-- v-if="detailData.platform.value === 50" -->
            <div  class="need-class" v-if="detailData.platform.value !== 40">
                <div>收藏：{{ detailData.starQuantity === 0?'-':detailData.starQuantity }}</div>
            </div>
            <!-- 20是抖音   抖音没有转发 -->
            <div v-if="(detailData.platform.value !== 50 || detailData.platform.value !==20) && detailData.forwardQuantity" class="need-class">
                <div>转发：{{ detailData.forwardQuantity === 0?'-':detailData.forwardQuantity }}</div>
            </div>
            <div class="need-class">
                <!--                免稿件exemptManuscriptFlag ===1-->
                <div
                    v-if="detailData.exemptManuscriptFlag === 0"
                    style="width: 50%"
                >
                    交稿截止：{{ detailData.handoverEndTime }}
                </div>
                <div style="width: 50%">
                    结算日期：{{ detailData.settleEndTime }}
                </div>
            </div>
            <!--            <div class="need-class" style="padding-bottom: 20px">-->
            <!--                注：报名后，发布平台达到上述标准并成功提交一周后结算。-->
            <!--            </div>-->
            <div class="brand-detail-title">详细要求</div>
            <div>
                <div class="richText" style="white-space: pre-line;" v-html="detailData.description"></div>
            </div>
            <div
                v-if="detailData.material && detailData.material.length !== 0"
                class="brand-detail-title"
            >
                任务素材
            </div>
            <div v-if="detailData.material && detailData.material.length !== 0">
                <div class="material-info-box">
                    <van-image-preview
                        v-if="detailData.material"
                        v-model="previewShow"
                        :closeable="true"
                        :start-position="startPosition"
                        :images="detailData.material"
                    >
                    </van-image-preview>
                    <img
                        class="material-img"
                        v-for="(item, index) in detailData.material"
                        @click="handlePreviewImg(index)"
                        :key="index"
                        :src="item"
                    />
                </div>
            </div>
        </div>

        <!--        <div class="card-box">-->
        <!--            <div class="task-tabs-container">-->
        <!--                <van-tabs v-model="currentTab">-->
        <!--                    <van-tab title="任务信息" name="task">-->
        <!--                        <div class="info-container">-->
        <!--                            <span class="item-title">任务要求</span>-->
        <!--                            <div class="yq-box">-->
        <!--                                <span class="yq-child" v-if="detailData.exposureQuantity">-->
        <!--                                    <span class="label">曝光要求：</span>-->
        <!--                                    <span class="value">{{detailData.exposureQuantity}}</span>-->
        <!--                                </span>-->
        <!--                                <span class="yq-child" v-if="detailData.commentQuantity">-->
        <!--                                    <span class="label">评论要求：</span>-->
        <!--                                    <span class="value">{{detailData.commentQuantity}}</span>-->
        <!--                                </span>-->
        <!--                                <span class="yq-child" v-if="detailData.likeQuantity">-->
        <!--                                    <span class="label">点赞要求：</span>-->
        <!--                                    <span class="value">{{detailData.likeQuantity}}</span>-->
        <!--                                </span>-->
        <!--                                <span class="yq-child" v-if="detailData.forwardQuantity">-->
        <!--                                    <span class="label">转发要求：</span>-->
        <!--                                    <span class="value">{{detailData.forwardQuantity}}</span>-->
        <!--                                </span>-->
        <!--                                <span class="yq-child" v-if="detailData.starQuantity">-->
        <!--                                    <span class="label">收藏要求：</span>-->
        <!--                                    <span class="value">{{detailData.starQuantity}}</span>-->
        <!--                                </span>-->
        <!--                            </div>-->
        <!--                            <span class="item-title">详细要求</span>-->
        <!--                            <div class="yq-other">-->
        <!--                                <div class="richText" v-html="detailData.description"></div>-->
        <!--                            </div>-->
        <!--                        </div>-->
        <!--                    </van-tab>-->
        <!--                    <van-tab title="品牌介绍" name="brand">-->
        <!--                        <div class="info-container">-->
        <!--                            <span class="item-title">品牌简介</span>-->
        <!--                            <span class="brandIntroduction">{{detailData.brandIntroduction}}</span>-->
        <!--                        </div>-->
        <!--                    </van-tab>-->
        <!--                </van-tabs>-->
        <!--            </div>-->
        <!--        </div>-->

        <!--        <template v-if="currentTab === 'task'">-->
        <!--            <template v-if="detailData.products && detailData.products.length > 0">-->
        <!--                <span class="step-title">推广商品</span>-->
        <!--                <div class="card-box product-info-box">-->
        <!--                    <div class="product-info-goods" v-for="item in detailData.products" :key="item.name">-->
        <!--                        <img class="goods-img" :src="item.imageUrl" />-->
        <!--                        <div class="goods-right">-->
        <!--                            <div class="row">-->
        <!--                                <span class="label">商品名称：</span>-->
        <!--                                <span v-if="detailData.type.value === 20" class="type-text">免单</span>-->
        <!--                                <span v-else class="type-text"><span v-if="detailData.marketType.value === 10">图文直发</span><span v-if="detailData.marketType.value === 20">商品{{detailData.marketHandleType.value===20 ?-->
        <!--                                    '需':''}}{{detailData.marketHandleType && detailData.marketHandleType.desc}}</span></span>-->
        <!--                            </div>-->
        <!--                            <div class="value">{{item.name}}</div>-->
        <!--                            <div class="row" style="padding-top: 17px;">-->
        <!--                                <span class="label">商品价格：</span>-->
        <!--                            </div>-->
        <!--                            <div class="value">{{item.price}} 元</div>-->
        <!--                        </div>-->
        <!--                    </div>-->
        <!--                    <div class="shop-address" v-if="detailData.type.value === 20">-->
        <!--                        <p>店铺地址</p>-->
        <!--                        <p>{{detailData.merchantAddressRealName}}</p>-->
        <!--                        <p>{{detailData.merchantAddress}}</p>-->
        <!--                    </div>-->
        <!--                </div>-->
        <!--            </template>-->

        <!--            <template v-if="detailData.material && detailData.material.length > 0">-->
        <!--                <span class="step-title" v-if="detailData.material.length > 0">任务素材</span>-->
        <!--                <div class="material-info-box">-->
        <!--                    <van-image-preview v-if="detailData.material" v-model="previewShow" :closeable="true" :start-position="startPosition" :images="detailData.material">-->
        <!--                    </van-image-preview>-->
        <!--                    <img class="material-img" v-for="(item, index) in detailData.material" @click="handlePreviewImg(index)" :key="index" :src="item" />-->
        <!--                </div>-->
        <!--            </template>-->
        <!--        </template>-->
        <!--        <template v-else>-->
        <!--            <div class="card-box" v-if="detailData.brandDescription">-->
        <!--                <div class="brand-detail-title">详细介绍</div>-->
        <!--                <div class="richText" v-html="detailData.brandDescription"></div>-->
        <!--            </div>-->
        <!--        </template>-->

        <div class="bottom-box">
            <div class="icon-box" @click="handleAttentionChange">
                <img
                    style="width: 22px; height: 20px"
                    v-if="
                        detailData.attentionFlag &&
                        detailData.attentionFlag.value === 0
                    "
                    src="../../assets/taskDetail/not.png"
                />
                <img
                    style="width: 22px; height: 20px"
                    v-else
                    src="../../assets/taskDetail/like.png"
                />
            </div>
            <div class="icon-box share-btn">
                <!--                <img src="../../assets/bottom/share-default.png" />-->
                <!--                <img style="width: 20px;height: 20px" open-type="share" src="../../assets/taskDetail/share.png" />-->
                <!--                <button open-type="share">分享</button>-->
            </div>
            <template
                v-if="detailData.applyFlag && detailData.applyFlag.value === 0"
            >
                <van-button
                    v-if="detailData.applyFlag && detailData.status.value === 30"
                    class="join-btn"
                    @click="goToDownload"
                    >报名参加</van-button
                >
                <van-button class="join-btn" v-else disabled
                    >报名已结束</van-button
                >
            </template>
            <van-button v-else class="join-btn disable" @click="goToDownload"
                >已报名</van-button
            >
        </div>
        <!--        <a-modal :visible="previewVisible" :footer="null" @cancel="previewVisible = false">-->
        <!--            <img alt="example" style="width: 100%" :src="imgSrc" />-->
        <!--        </a-modal>-->
        <van-popup :show="previewVisible">
            <img style="width: 100%" :src="imgSrc" />
        </van-popup>
    </div>
</template>
<script>
import { fetchTaskById, getBrandId } from "../../services/taskDetail";
import axios from "@/utils/miniAxios";
import moment from "moment";
import { Toast } from "vant";
moment.locale("zh-cn");
const platformColor = {
    10: "#FF0000",
    20: "#170B1A",
    30: "#FF8000",
    40: "#FFC862",
    50: "#FF6633",
    60: "#46BB36",
};

export default {
    data() {
        return {
            attentionCount: "",
            signUpTime: 30 * 60 * 60 * 1000,
            previewShow: false,
            startPosition: 0,
            taskId: "",
            detailData: {},
            showYQ: true,
            currentTab: "task",
            attentionForm: {
                quoteId: "",
                type: 10,
            },
            brandId: "",
            imgSrc: "",
            previewVisible: false,
            remainingTime: "",
        };
    },
    mounted() {
        const query = this.$route.params;
        this.taskId = query.id;
        this.attentionForm.quoteId = query.id;
        this.handleGetPageData();
    },
    methods: {
        goToAddress(row) {
            // position：经纬度
            if (row.merchantAddressLatitude) {
                const position =
                    row.merchantAddressLongitude +
                    "," +
                    row.merchantAddressLatitude;
                window.open(
                    "https://uri.amap.com/marker?position=" +
                        position +
                        "&name=" +
                        row.merchantAddress
                );
            }
        },
        callPhone(phoneNumber) {
            window.location.href = "tel://" + phoneNumber;
        },
        previewImage(src) {
            this.previewVisible = true;
            this.imgSrc = src;
        },
        goToBrand() {
            this.$router.push({
                path: "/brandDetail/" + this.brandId,
            });
        },
        handleAttentionChange() {
            let url = "/api/user/attentions";
            let showText = "关注";
            let value = 1;
            if (this.detailData.attentionFlag.value === 1) {
                url += "/cancel";
                showText = "取消关注";
                value = 0;
            }
            axios({
                url: url,
                method: "post",
                data: this.attentionForm,
            })
                .then((res) => {
                    Toast.success(showText + "成功");
                    this.detailData.attentionFlag.value = value;
                })
                .catch(() => {});
        },
        goToDownload() {
            console.log('跳转执行了');
            this.$router.push("/download");
            //
        },
        handlePreviewImg(index) {
            this.previewShow = true;
            this.startPosition = index;
        },
        handleGetPageData() {
            fetchTaskById(this.taskId).then((res) => {
                res.amount = (res.amount / 100).toFixed(2);
                if (
                    moment(res.applyEndTime, "YYYY-MM-DD HH:mm:ss").isBefore(
                        new Date()
                    )
                ) {
                    res.timeFromNow = "报名已结束";
                    this.remainingTime = "";
                } else {
                    res.timeFromNow = moment(
                        res.applyEndTime,
                        "YYYY-MM-DD HH:mm:ss"
                    ).fromNow();
                    const g = new Date().getTime();
                    res.applyEndTime = res.applyEndTime.replace(/-/g, "/");
                    const applyEndTime = new Date(res.applyEndTime).getTime();
                    this.remainingTime = applyEndTime - g;
                }
                res.handoverEndTime = moment(
                    res.handoverEndTime,
                    "YYYY-MM-DD HH:mm:ss"
                ).format("YYYY-MM-DD");
                res.settleEndTime = moment(
                    res.settleEndTime,
                    "YYYY-MM-DD HH:mm:ss"
                ).format("YYYY-MM-DD");
                res.platformColor = platformColor[res.platform.value];
                res.brandLogoUrl =
                    "https://wowoto.oss-cn-shanghai.aliyuncs.com/pinboo/" +
                    res.brandLogoUrl;
                if (!res.products) res.products = [];
                res.products = res.products.map((item) => {
                    return {
                        ...item,
                        price: item.price / 100,
                        imageUrl:
                            "https://wowoto.oss-cn-shanghai.aliyuncs.com/pinboo/" +
                            item.imageUrl,
                    };
                });
                try {
                    const material = JSON.parse(res.material);
                    res.material = material.images.map((item) => {
                        return (
                            "https://wowoto.oss-cn-shanghai.aliyuncs.com/pinboo/" +
                            item
                        );
                    });
                } catch (e) {
                    res.material = [];
                }
                // res.description += `<style>img{width: 100px;}</style>`
                if (res.description.includes("<img class=")) {
                    res.description = res.description.replaceAll(
                        /<img class="/gi,
                        '<img class="rich-img '
                    );
                } else {
                    res.description = res.description.replaceAll(
                        /<img/gi,
                        '<img class="rich-img"'
                    );
                }
                if (res.brandDescription.includes("<img class=")) {
                    res.brandDescription = res.brandDescription.replaceAll(
                        /<img class="/gi,
                        '<img class="rich-img '
                    );
                } else {
                    res.brandDescription = res.brandDescription.replaceAll(
                        /<img/gi,
                        '<img class="rich-img"'
                    );
                }
                this.detailData = res;
                this.brandId = this.detailData.brandId;
                getBrandId(this.brandId).then((res) => {
                    this.attentionCount = res.attentionCount;
                });
            });
        },
    },
};
</script>
<style lang="less">
.task-detail-container {
    padding: 0 16px;
    padding-top: 15px;
    margin-bottom: 85px;
    background-color: #f7f4ed;
    .bottom-box {
        height: 60px;
        background-color: #ffffff;
        box-shadow: 0 1px 5px 0 #d8d8d8;
        position: fixed;
        padding-bottom: env(safe-area-inset-bottom);
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 999;
        display: flex;
        align-items: center;
    }

    .bottom-box .icon-box {
        // flex: 1;
        // display: flex;
        // align-items: center;
        // justify-content: center;
        margin-left:50px;
    }

    //.bottom-box .icon-box img {
    //    width: 22px;
    //    height: 22px;
    //}

    .bottom-box .join-btn {
        width: 240px;
        height: 35px;
        // background: linear-gradient(180deg, #ff6d26 0%, #f7b500 100%);
        background-color: #17C1CE;
        border-radius: 7px;
        line-height: 35px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
    }
}

.card-box {
    background: #ffffff;
    box-shadow: 0 1px 5px 0 #d8d8d8;
    border-radius: 8px;
    padding: 13px 15px;
    margin-bottom: 18px;
}

.sign-total {
    display: flex;
    flex-direction: row;
    padding-top: 19px;
}

.label-sign {
    width: 66px;
    height: 18px;
    line-height: 18px;
    // background: linear-gradient(180deg, #ff6d26 0%, #f7b500 100%);
    background-color: #17C1CE;
    color: #ffffff;
    font-family: PingFangSC-Regular, PingFang SC;
    font-size: 12px;
    border-radius: 2px;
    text-align: center;
    margin-right: 10px;
}

.task-info-box {
    position: relative;
}

.task-info-brand {
    display: flex;
    padding-top: 5px;
    /* height: 150rpx; */
}

.task-data-box .left-logo {
    // width: 105px;
    height: 142px;
    box-shadow: 0 1px 5px 0 #d8d8d8;
    border-radius: 5px;
}

.task-data-box .right-data {
    flex: 1;
    padding-left: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.right-data .cell {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    margin-top: 10px;
}

.right-data .cell .label {
    color: #aab2b7;
    padding-right: 10px;
}

.right-data .cell .value {
    color: rgba(0, 0, 0, 0.85);
}

.info-font {
    width: 320px;
    height: 24px;
    color: #ffffff;
    background-color: #17C1CE;
    font-family: PingFangSC-Regular, PingFang SC;
    font-size: 10px;
    border-radius: 4px;
    text-align: center;
    line-height: 24px;
    margin-top: 10px;
}

.task-info-brand .brand-logo {
    width: 32px;
    height: 32px;
    border-radius: 5px;
}

.task-info-brand .brand-right {
    padding-left: 10px;
    width: 160px;
}

.brand-right .task-name {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.85);
    margin-bottom: 6px;
}

//.brand-right .cell {
//    font-size: 12px;
//    font-family: PingFangSC-Regular, PingFang SC;
//    font-weight: 400;
//    margin-top: 10px;
//}
//
//.brand-right .cell .label {
//    color: #AAB2B7;
//    padding-right: 10px;
//}
//
//.brand-right .cell .value {
//    color: rgba(0, 0, 0, 0.85);
//}

//.brand-right .task-platform {
//    display: inline-block;
//    min-width: 36px;
//    padding: 0 5px;
//    height: 17px;
//    background: #F3990F;
//    box-shadow: 0 5px 11px 0 rgba(0, 0, 0, 0.05), 0 3px 5px 0 rgba(74, 144, 226, 0.1);
//    border-radius: 3px;
//    font-size: 10px;
//    font-family: PingFangSC-Regular, PingFang SC;
//    font-weight: 400;
//    color: #FFFFFF;
//    line-height: 17px;
//    text-align: center;
//}

.task-info-box .task-type-icon {
    border-radius: 0 10px 0 0;
    width: 53px;
    height: 82px;
    // background: linear-gradient(180deg, #ff6d26 0%, #f7b500 100%);
    background-color: #17C1CE;
    //border-top-left-image: #FF6D26;
    //border-top-image: #FF6D26;
    //border-top-right-image: #FF6D26;
    //border-left-image:#FF6D26;
    //border-bottom-left-image: #F7B500;
    //border-top: 65px solid  #FF6D26;
    //border-right: 32px solid  #F7B500;
    //border-left: 32px solid #F7B500;
    //border-bottom: 30px solid transparent;
    //width: 52px;
    //height: 0;
    //border: 10px solid;
    position: absolute;
    top: 0;
    right: 0;
    //border-bottom: 10px solid transparent;
}
.sanjiaoxing {
    width: 0;
    height: 0;
    border-top: 28px solid transparent;
    border-right: 26px solid transparent;
    border-left: 26px solid transparent;
    border-bottom: 28px solid #ffffff;
    position: absolute;
    right: 0;
    top: 26px;
}
.typeLogo {
    text-align: center;
    font-size: 14px;
    font-family: PingFang-SC-Bold;
    color: #ffffff;
    font-weight: bold;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 45px;
    padding:5px 0;
}

.task-info-box .task-data-box {
    position: relative;
    padding-top: 50px;
    display: flex;
}
.richText {
    word-break: break-all;

    b, strong, [style*="font-weight: bold"], [style*="font-weight:bold"] {
        font-weight: bold !important;
        display: inline-block;
    }

    h3 b, h3 strong, p b, p strong {
        font-weight: bold !important;
        display: inline-block;
    }
}

.brand-right::after {
    position: absolute;
    left: 15px;
    right: -15px;
    top: 125px;
    content: " ";
    height: 1px;
    background: #eeeeee;
}

.task-info-brand .brand-rightTwo {
    padding-left: 10px;
    width: 160px;
}

.brand-rightTwo .task-name {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.85);
    margin-bottom: 6px;
}
.brand-rightTwo::after {
    position: absolute;
    left: 15px;
    right: -15px;
    top: 100px;
    content: " ";
    height: 1px;
    background: #eeeeee;
}

//.task-data-box::after {
//    position: absolute;
//    left: 15px;
//    right: -15px;
//    bottom: 0;
//    content: " ";
//    height: 1px;
//    background: #EEEEEE;
//}

.task-data-box .row {
    display: flex;
    align-items: center;
    padding-bottom: 12px;
}

//.task-data-box .row .cell {
//    flex: 1;
//    font-size: 12px;
//}
//
//.task-data-box .row .cell .label {
//    font-family: PingFangSC-Regular, PingFang SC;
//    font-weight: 400;
//    color: #AAB2B7;
//}
//
//.task-data-box .row .cell .money {
//    font-size: 16px;
//    font-family: ArialMT;
//    color: #FF6D26;
//}
//
//.task-data-box .row .cell .value {
//    font-family: ArialMT;
//    color: rgba(0, 0, 0, 0.85);
//}

.task-info-box .task-tabs-container {
    margin-top: 10px;
}

.task-tabs-container .van-tabs__wrap {
    height: 32px !important;
    margin: 0 auto;
    border-radius: 7px;
    border: 1px solid #d8d8d8;
}

.task-tabs-container .van-ellipsis {
    line-height: 32px;
}

.task-tabs-container .van-tab--active {
    color: white;
    // background: linear-gradient(180deg, #ff6d26 0%, #f7b500 100%);
    background-color: #17C1CE;
    border-radius: 7px;
}

.task-tabs-container .van-tab--active .van-ellipsis {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
}

.task-tabs-container .van-tabs__line {
    display: none;
}

.task-tabs-container .info-container .item-title {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.85);
    margin-top: 17px;
    display: block;
}

.info-container .yq-box {
    display: flex;
    flex-flow: row wrap;
    align-content: flex-start;
}

.yq-box .yq-child {
    flex: 0 0 50%;
    margin-top: 16px;
}

.yq-child .label {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #aab2b7;
}

.yq-child .value {
    font-size: 14px;
    font-family: ArialMT;
    color: #171f24;
}

.yq-other {
    padding-top: 10px;
}

rich-text .rich-img {
    width: 100%;
    height: auto;
}

.step-title {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.85);
    margin-bottom: 14px;
    display: block;
}

.product-info-box {
}

.product-info-box .product-info-goods {
    display: flex;
}

.product-info-goods .goods-img {
    width: 100px;
    height: 100px;
    border-radius: 5px;
}

.product-info-goods .goods-right {
    padding-left: 20px;
    flex: 1;
}

.goods-right .row {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.goods-right .type-text {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    // color: #ff6d26;
    color:#17C1CE;
}

.goods-right .label {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #aab2b7;
}

.goods-right .value {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
}

.material-info-box {
    display: flex;
    flex-direction: column;
    // flex-flow: row wrap;
    // align-content: flex-start;
}

.material-info-box .material-img {
    // width: 105px;
    // height: 105px;
    border-radius: 5px;
    margin-right: 12px;
    margin-bottom: 12px;
}

.material-info-box .material-img:nth-of-type(3n) {
    margin-right: 0;
}

.brandIntroduction {
    margin-top: 17px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #6d7278;
    display: block;
}

.brand-detail-title {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.85);
    padding-bottom: 10px;
}

.join-btn.disable {
    background: #d8d8d8;
}
.shop-address {
    p {
        font-size: 14px;
        &:nth-of-type(1) {
            font-weight: 600;
        }
        &:nth-of-type(2),
        &:nth-of-type(3) {
            font-size: 13px;
        }
    }
}

.brandLogoUrl {
    width: 20px;
    height: 20px;
    border-radius: 10px;
}

.brand-name {
    font-size: 14px;
    font-family: PingFangSC-Medium;
    font-weight: bold;
    margin-left: 10px;
    display: inline-block; /* 使元素成为块级元素 */
    width: 160px; /* 设置最大宽度为10个字符 */
    overflow: hidden; /* 超出部分隐藏 */
    white-space: nowrap; /* 禁止换行 */
    text-overflow: ellipsis; /* 使用省略号表示超出部分 */
}
.brand-attention{
    font-size: 14px;
    font-family: PingFangSC-Medium;
    font-weight: bold;
    margin-left: 10px;
}
.heart {
    width: 13px;
    margin-right: 10px;
}

.time-period {
    width: 320px;
    height: 24px;
    // color: #ff7e20;
    color:#17C1CE;
    background: #ffffff;
    font-family: PingFangSC-Medium, PingFang SC;
    font-size: 12px;
    border-radius: 4px;
    text-align: center;
    line-height: 24px;
    margin-top: 20px;
    border: #17C1CE solid 1px;
}

.task-require-class .need-class {
    display: flex;
    flex-direction: row;
    padding-bottom: 10px;
    font-size: 12px;
    font-family: PingFangSC-Medium;
}
.task-require-class .title-class {
    display: flex;
    flex-direction: row;
}
.task-require-class .count-down {
    right: 18px;
    position: absolute;
    font-size: 12px;
    color: #ff7e20;
}
.shop-icon {
    width: 15px;
    height: 15px;
}
.shop-font {
    font-size: 12px;
    font-family: PingFangSC-Medium;
    color: #999999;
    margin-left: -5px;
}
.line {
    display: flex;
    flex-direction: column;
    position: absolute;
    right: 65px;
}
.navigation {
    display: flex;
    flex-direction: column;
    position: absolute;
    right: 80px;
    margin-top: -10px;
}
.phone {
    display: flex;
    flex-direction: column;
    position: absolute;
    right: 30px;
    margin-top: -10px;
}
</style>
